export default "__VITE_ASSET__BA9maTW5__"